import { Box, Container, Typography } from "@mui/material";
import BackButton from "../../../components/BackButton/index.js";
import AuthContainer from "../../../components/Containers/AuthContainer.js";
import appcolors from "../../../constants/Colors.js";
import ForgotForm from "./ForgotForm.js";
import { Trans } from "react-i18next";
import { t } from "i18next";

const ForgotPassword = () => {
  return (
    <AuthContainer>
      <Box position={"absolute"} top={30} left={15}>
        <BackButton />
      </Box>
      <Container sx={{ maxWidth: "550px !important" }}>
        <Typography
          variant="auth_primary"
          component={"h1"}
          textAlign={"center"}
        >
          {t("forgotPassword")}
        </Typography>
        <Typography variant="auth_secondary_text" component={"p"}>
          <Trans
            i18nKey="welcomeForgotMessage"
            style={{ color: appcolors.slateGrey }}
            color={appcolors.slateGrey}
          >
            Welcome to <b style={{ color: "black" }}>Eaziday</b> CRM, Please
            give us email address and password
          </Trans>
        </Typography>
        <ForgotForm />
      </Container>
    </AuthContainer>
  );
};

export default ForgotPassword;
